import { render, staticRenderFns } from "./ConfidenceSubsection.vue?vue&type=template&id=a165c50a"
import script from "./ConfidenceSubsection.vue?vue&type=script&lang=ts"
export * from "./ConfidenceSubsection.vue?vue&type=script&lang=ts"
import style0 from "./ConfidenceSubsection.vue?vue&type=style&index=0&id=a165c50a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports